import flexBoxThree from "./flexBoxThree";
import defaultHeader from "./defaultHeader";
import dsfCardImage from "./dsfCardImage";

export default [flexBoxThree, defaultHeader, dsfCardImage];